import { Chip, Tooltip } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import type { RetiredField } from "../../api/types";

export type RetiredFieldChipProps = {
  field: RetiredField;
};

/**
 * A condition, action or matcher on a field that no longer exists. The
 * backend still loads it — as a leaf that never matches, or an action that
 * does nothing — and reports the rule as dead until it is removed, so the
 * editor shows it read-only rather than offering a picker for a value that
 * cannot be set. Saving is refused while one remains (see
 * `retiredConditionLabels` / `retiredActionLabels`).
 */
export const RetiredFieldChip = ({ field }: RetiredFieldChipProps) => (
  <Tooltip
    title={`The ${field} field is retired and no longer exists. Remove this before saving.`}
  >
    <Chip
      icon={<WarningAmberIcon />}
      color="warning"
      variant="outlined"
      size="small"
      label={`${field} (retired)`}
    />
  </Tooltip>
);
